import { z } from 'zod';
import { ModelCode, ModelCodesSchema } from '@/types/model-code.type.ts';
import { ModelStatus } from '@/types/model/model-status.type.ts';

export type Model = {
    id: number,
    brand_id: number,
    name: string,
    symbolic_code: string,
    status: ModelStatus,
    created_at?: string,
    model_codes?: ModelCode[],
};

export const ModelSchema = z.object({
    id: z.number(),
    brand_id: z.number(),
    name: z.string(),
    symbolic_code: z.string().optional(),
    status: z.nativeEnum(ModelStatus).optional(),
    created_at: z.string().optional(),
    model_codes: ModelCodesSchema.optional(),
});
